import { leaveManagementServiceApi } from "../../app/leaveManagementServiceApi";
import { API_URL } from "../../constants/apiUrl";
import {
  GetDashboardLeaveAnalyticsDataParams,
  GetDashboardLeaveAnalyticsDataResponseType,
  GetLeaveApplicationDetailsResponseType,
  GetLeaveApplicationParams,
  GetLeaveApplicationResponseType,
  GetQueryArgsType,
  PatchQueryArgsType,
} from "../../types";
import {
  GetDashboardLeaveDataParams,
  GetDashboardLeaveDataResponseType,
} from "../../types/dashboard";

export const leaveApplicationApi = leaveManagementServiceApi.injectEndpoints({
  endpoints: (builder) => ({
    addLeaveApplication: builder.mutation({
      query: (data) => ({
        url: API_URL.addLeaveApplication,
        method: "POST",
        body: data,
      }),
    }),
    updateLeaveApplication: builder.mutation<void, PatchQueryArgsType>({
      query: ({ id, body }) => ({
        url: `${API_URL.updateLeaveApplication}/${id}`,
        method: "PATCH",
        body,
      }),
      invalidatesTags: (result, _, { id }) => {
        if (result)
          return [
            "GetLeaveApplicationList",
            {
              type: "GetLeaveApplicationDetails",
              id,
            },
          ];

        return [];
      },
    }),
    getLeaveApplicationList: builder.query<
      GetLeaveApplicationResponseType,
      GetQueryArgsType<GetLeaveApplicationParams>
    >({
      query: (queryArgs) => ({
        url: API_URL.getLeaveApplicationList,
        ...queryArgs,
      }),
      providesTags: ["GetLeaveApplicationList"],
    }),
    getLeaveApplicationDetails: builder.query<
      GetLeaveApplicationDetailsResponseType,
      number
    >({
      query: (id) => ({
        url: `${API_URL.getLeaveApplicationDetails}/${id}`,
      }),
      providesTags: (_, __, id) => [
        {
          type: "GetLeaveApplicationDetails",
          id,
        },
      ],
    }),
    updateLeaveApplicationApproved: builder.mutation<
      unknown,
      PatchQueryArgsType
    >({
      query: ({ id, body }) => ({
        url: `${API_URL.updateLeaveApplicationApproved}/${id}`,
        method: "PATCH",
        body,
      }),
      invalidatesTags: (result, _, { id }) => {
        if (result)
          return [
            "GetLeaveApplicationList",
            {
              type: "GetLeaveApplicationDetails",
              id,
            },
          ];

        return [];
      },
    }),
    updateLeaveApplicationReject: builder.mutation<unknown, PatchQueryArgsType>(
      {
        query: ({ id, body }) => ({
          url: `${API_URL.updateLeaveApplicationReject}/${id}`,
          method: "PATCH",
          body,
        }),
        invalidatesTags: (result, _, { id }) => {
          if (result)
            return [
              "GetLeaveApplicationList",
              {
                type: "GetLeaveApplicationDetails",
                id,
              },
            ];

          return [];
        },
      }
    ),
    updateLeaveApplicationCancel: builder.mutation<unknown, PatchQueryArgsType>(
      {
        query: ({ id, body }) => ({
          url: `${API_URL.updateLeaveApplicationCancel}/${id}`,
          method: "PATCH",
          body,
        }),
        invalidatesTags: (result, _, { id }) => {
          if (result)
            return [
              "GetLeaveApplicationList",
              {
                type: "GetLeaveApplicationDetails",
                id,
              },
            ];

          return [];
        },
      }
    ),

    getDashboardLeaveData: builder.query<
      GetDashboardLeaveDataResponseType,
      GetQueryArgsType<GetDashboardLeaveDataParams>
    >({
      query: (queryArgs) => ({
        url: API_URL.getDashboardLeaveData,
        ...queryArgs,
      }),
    }),

    getDashboardLeaveAnalyticsData: builder.query<
      GetDashboardLeaveAnalyticsDataResponseType,
      GetQueryArgsType<GetDashboardLeaveAnalyticsDataParams>
    >({
      query: (queryArgs) => ({
        url: API_URL.getDashboardLeaveAnalyticsData,
        ...queryArgs,
      }),
    }),
  }),
});

export const {
  useAddLeaveApplicationMutation,
  useUpdateLeaveApplicationMutation,
  useGetLeaveApplicationListQuery,
  useGetLeaveApplicationDetailsQuery,
  useUpdateLeaveApplicationApprovedMutation,
  useUpdateLeaveApplicationRejectMutation,
  useUpdateLeaveApplicationCancelMutation,
  useGetDashboardLeaveDataQuery,
  useGetDashboardLeaveAnalyticsDataQuery,
} = leaveApplicationApi;
